<template>
  <div id="servizi">
    <h1 class="font-weight-light w3-serif ml-12">
      I nostri servizi
    </h1>
    <br>
    <div class="d-flex flex-wrap justify-space-around mb-16">
      <v-card class="mx-auto mb-4" :max-width="servicesCardWidth" v-for="service in services" :key="service.title">
        <v-img class="white--text align-end" height="200px" :src="service.src"></v-img>
        <v-card-title :class="servicesCardTitleColor" :style="[$isMobile() ? {'font-size': '16px'} : {'font-size': '20px'}]">
          {{service.title}}
        </v-card-title>
        <v-card-text class="text--primary">
          <div>
            {{service.text}}
          </div>
        </v-card-text>
      </v-card>
    </div>
  </div>

</template>

<script>
  export default {
    name: 'Servizi',
    data: () => ({
      servicesCardWidth: "30%",
      servicesCardTitleColor: "desktop-text-color",
      services:{
        first: {
          src: require("../assets/primoServizio.jpg"),
          title: "Realizzazione di nuove costruzioni",
          text: "Utilizzo di materiali e attrezzature all’avanguardia e innovative tecniche di lavorazione, trovando la corretta soluzione nella combinazione di tecniche antiche e prodotti moderni.",
        },
        second: {
          src: require("../assets/secondoServizio.jpg"),
          title: "Manutenzione, restauro e risanamento",
          text: "Interventi specializzati in manutenzione, restauro, consolidamenti, ristrutturazioni, recupero edilizio.",
        },
        third: {
          src: require("../assets/terzoServizio.jpg"),
          title: "Consulenze edili su misura",
          text: "Risposte rapide ed appropriate ad ogni esigenza, di ogni tipo e genere, sia in ambito industriale, agricolo, privato e pubblico.",
        } 
      }
    }),
    created: function(){
      console.log("created");
      if(this.$isMobile()){
        this.servicesCardWidth = "320px";
        this.servicesCardTitleColor = "";
      } 
    },
  }
</script>
